
<template>
  <div class="page" v-if="!success">
    <div class="container" style="max-width:800px; margin:0 auto;">
      <div class="section" id="section-header">
        <div class="container" style="text-align: center; font-size: 24px">
          <h1>정비/수리 견적 요청서</h1>
        </div>
      </div>
      <div class="section">
        <p style="font-size: 20px">
          사장님, 안녕하세요 <br />
          하단의 정비/수리 요청내용을 보신 후 맨 밑의 총 견적금액 및 상세내용을 입력부탁드립니다.
        </p>
      </div>
      <div class="section">
        <el-row>
          <el-col :xs="24" :sm="12" :md="12">
            <el-row>
              <el-col :span="4">차량정보:</el-col>
              <el-col :span="20">{{models.repair_estimate.autocode_name}}</el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-row>
              <el-col :span="4">희망항목:</el-col>
              <el-col :span="20">{{models.repair_estimate.repair_items}}</el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-row>
              <el-col :span="4">추가메모:</el-col>
              <el-col :span="20">{{models.repair_estimate.reservation_memo}}</el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div>
        <div>이미지:</div>
        <el-row class="img-row">
          <el-col :xs="24" :sm="12" :md="6"
              class="img-each"
              v-for="(i, index) in lists.upload_list"
              :key="index"
          >
            <el-image :src="i" alt="" :preview-src-list="[i]" />
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="4">업체명:</el-col>
        <el-col :span="20">{{models.repair_estimate_compare.company_name}}</el-col>
      </el-row>
      <div class="title-area mb-32 mx-20" style="margin-bottom: 100px;">
        <h4 style="font-weight:bold; color:#666666;">총 견적금액 </h4>
        <input
            class="input-box-border"
            style="background-color: #fff"
            v-model="models.repair_estimate_compare.amount"
            type="tel" pattern="[\d,]*"
            inputmode="numeric"
            placeholder="숫자만 입력해주세요."
        />
      </div>
      <div class="title-area mb-32 mx-20">
        <h4 style="font-weight:bold; color:#666666;">견적 상세내용: </h4>
        <textarea
            class="textarea-box-border"
            v-model="models.repair_estimate_compare.memo"
            type="text"
            maxlength="500"
            rows="5"
            placeholder="견적에 대한 상세 내용이 있는 경우 입력해주세요"
        ></textarea>
      </div>
      <div style="clear:both;"></div>
      <div class="section">
        <div>
          <div class="section-signature">
            <div style="clear:both;"></div>
            <div style="margin-top:50px;">
              <button style="background: #0b2573;color: #fff; display: block; margin:0 auto; height: 35px; width:100%;" @click="onsubmit()">{{models.isEdit ? '수정' : '저장'}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 신청 완료시 완료 화면 -->
  <Success v-else-if="success"
           :contents="models.isEdit ? '견적서 수정이 <br> 완료되었습니다.' : '견적서 입력이 <br> 완료되었습니다.'"
           :customOK="clickOkay">
  </Success>
</template>

<style>
html, body{ width:100%; overflow-x: hidden;}
.section {
  margin-top: 24px;
}
</style>

<script>
import Vue from "vue"
import {Row, Col, Image} from 'element-ui'
import Success from '@/components/Elements/Success'

export default {
  props: [],
  components: {[Row.name]: Row,[Col.name]: Col, [Image.name]: Image, Success},
  data(){
    return {
      numPages: undefined,
      success: false,
      models : {
        admin : null,
        repair_estimate: {},
        repair_estimate_compare: {
          amount: null,
          memo: ''
        },
        isEdit: false
      },
      lists: {
        upload_list : []
      },
    }
  },
  created() {
    this.init()
  },
  watch: {
    'models.repair_estimate_compare.amount': function(newValue) {
      const result = String(newValue || '').replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      Vue.nextTick(() => this.models.repair_estimate_compare.amount = result);
    }
  },
  methods: {
    init() {
      this.get_repair_estimate_compare(this.$route.query.repairEstimateCompareId)
      .then(({data}) => {
        data && this.get_repair_estimate(data.repair_estimate_id)
      })
    },
    get_repair_estimate_compare(id) {
      if (!id) {
        return Promise.resolve(false)
      }
      return this.$store.dispatch('repair/getCompareItem', { repairCompareId: id })
        .then(({data}) => {
          this.models.repair_estimate_compare = data.data
          this.models.isEdit = Boolean(data.data.amount)
          return data
        })
    },
    update_repair_estimate_compare() {
      const params = {
        repairCompareId: this.models.repair_estimate_compare._id,
        data: {
          amount: (this.models.repair_estimate_compare.amount || ',').replace(/,/g, ''),
          memo: this.models.repair_estimate_compare.memo
        }
      };
      return this.$store.dispatch(`repair/editCompareItem`, params)
        .then(() => {
          const params = {
            repairEstimateId: this.models.repair_estimate._id,
            data: {
              repair_estimate_status: '견적도착'
            }
          }
          return this.$store.dispatch('repair/edit', params)
      })
    },
    get_repair_estimate(id) {
      if (!id) {
        return false
      }
      return this.$store.dispatch('repair/get', { repairId: id })
        .then(({data}) => {
          this.models.repair_estimate = data.data
          this.load_list(data.data.resource_key)
        })
    },
    onsubmit() {
      this.update_repair_estimate_compare()
      .then(() => {
        this.success = true
      })
    },
    load_list(resource_key) {
      const _params = { "key": resource_key, "page": 1, "size": 100 }
      this.$store.dispatch('repair/getResourceItems', {params:_params}).then(res => {
        let { data, error } = res.data;
        if (error) { return;  }
        this.$data.lists.upload_list = data.items.map(item => item.resource_url);
      })
    },
    clickOkay() {
      window.location.href = '/'
    }
  }
}
</script>
